const RingIcon = ({ width = 14, height = 15, color = "#0971A2", className = "fill-[#0971A2]" }) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 14 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            d="M7.375 10.5456V9.62889H12.25C12.25 6.23941 10.099 3.46574 7.375 3.23016V2.29558H8.125C8.125 1.78926 7.78926 1.37891 7.375 1.37891H6.625C6.21075 1.37891 5.875 1.78926 5.875 2.29558H6.625V3.23016C3.901 3.46578 1.75 6.23941 1.75 9.62889H6.625V10.5456H1V12.3789H13V10.5456H7.375ZM3.39175 8.37929L2.66988 8.12863C3.21713 5.77389 4.99728 4.12901 6.99993 4.12901V5.04568C5.33118 5.04568 3.8476 6.41625 3.39175 8.37929Z"
        />
    </svg>
);
export default RingIcon;
